<template>
  <ats
    v-bind="$props"
    service="greenhouse"
    :savingConf="savingConf"
    :credential="{ company: '', token: '' }"
    :cached="true"
    @input="onInput">
    <template v-slot:credential="{ credential }">
      <div>
        <label for="company">company</label>
        <input v-model="credential.company" id="company" name="company"/>
        <modified :enable="value.credential.company !== credential.company"/>
      </div>
      <div>
        <label for="token">token</label>
        <input v-model="credential.token" id="token" name="token"/>
        <modified :enable="value.credential.token !== credential.token"/>
      </div>
    </template>
  </ats>
</template>
<script>
import Ats from './sdk-v3'
import Recruiter from '/user/recruiter/recruiter.entity'
import Search from '/requirement/entity'
import Modified from '/ats/modified'

export default {
  name: 'hippolyte.services.greenhouse.config',
  components: { Ats, Modified },
  props: {
    value: Object,
    recruiter: Recruiter,
    search: Search,
    savingConf: Boolean
  },
  methods: {
    onInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
